import { useSpaceHeaderTitleDropdown } from "@/react/components/Spaces/Header/SpaceHeaderTitleDropdown/useSpaceHeaderTitleDropdown";
import {
  isChatSpace,
  isMembersSpace,
  isSpaceMember,
} from "@/react/helpers/spaceHelpers";
import { usePunditUserContext } from "@circle-react/contexts";

export const useNotificationBell = ({ space }) => {
  const { currentCommunity } = usePunditUserContext();
  const areMobileNotificationsEnabled =
    currentCommunity.ios_app_enabled || currentCommunity.has_branded_app;

  const shouldShowNotificationBell =
    !isChatSpace(space) || areMobileNotificationsEnabled;

  const {
    updateSpaceMemberNotificationPreferences,
    updateChatSpaceMemberNotificationPreferences,
    notificationState,
  } = useSpaceHeaderTitleDropdown({ space });
  const shouldShowNotificationsSection =
    !isMembersSpace(space) &&
    isSpaceMember(space) &&
    shouldShowNotificationBell;

  return {
    updateSpaceMemberNotificationPreferences,
    updateChatSpaceMemberNotificationPreferences,
    notificationState,
    shouldShowNotificationsSection,
  };
};
